export default {
    //ProjectsList
    your_created_projects: "Your created courses",
    new_project: "New Course",
    search_course_placeholder: "Search for your course...",
    projects_name: "COURSE NAME",
    update_at: 'Updated on ',
    coming_soon: 'Coming soon',
    search_your_project: 'Search for your course...',
    project_name: 'Course name',
    loading_projects: 'Loading proyects...',

    //ProjectEditComponent
    modify_project: 'Modifying your projects',
    general: 'General',
    layout: 'Template',
    access: 'Access',
    branding: 'Branding',
    product_page: 'Product Page',
    sale: 'Sale',
    seo_text: 'SEO',
    product: 'Product',

    //CategoriesSlideOverComponent
    categories: 'Categories',
    text_category: 'Classify your products by category to make it easier for your students to buy your courses.',
    select_category: 'Select category...',
    ebook: 'E-book',
    online_project: 'Online projects',
    blended_learning: 'Blended learning projects',
    online_program: 'Online Programme',
    webinar_consulting: 'Webinar / Online consulting',
    remove_category: 'Remove category',
    href_help: 'More about the categories',

    //Projectdit
    //CustomCategoriesComponent
    //GeneralComponent
    category: 'Category',
    duration: 'Duration',
    featured_product: 'Product Spotlight',
    publish_project: 'Publish Project',
    delete_project: 'Delete project',
    warning_delete: 'Warning!',
    message_delete_project: 'By deleting the projects you will permanently lose all your data.',
    question_delete_project: 'Are you sure you want to delete this projects?',
    delete: 'Delete',
    confirmation_delete_project: '(*) This box is required to delete the projects.',
    navigation: 'Navigation',
    navigation_free: 'Free',
    navigation_secuential: 'Sequential',
    navigation_without_restriction: 'No restrictions. The user will be able to navigate freely through the course (excluding courses with drip content).',
    navigation_completed_restriction: 'The learner has to complete each learning unit before continuing to the next one. The completion of the learning units can be established in different ways.',
    quest_lesson_complete: 'When will it be considered a completed lesson?',
    lesson_complete_at_visit: 'When visited',
    lesson_at_visit_info: 'When entering a lesson it will be automatically completed in the total progress of the course (Default).',
    lesson_complete_at_see: 'When viewing the content completely',
    lesson_at_see_info: 'It will be marked as completed when the content (video, ebook, podcast) is fully displayed.',
    lesson_complete_on_time: 'By remaining for a period of time',
    lesson_on_time_info: 'It will be completed when the indicated time (HH:mm) is in each lesson.',
    automatic_navigation: 'Automatic navigation',
    automatic_navigation_disabled: 'Disabled',
    automatic_navigation_enabled: 'Enabled',
    automatic_navigation_info: 'Completing the content of a lesson will take you to the next corresponding lesson.',
    //PageComponent
    principal_page: 'Home Page',
    objects_presentation: 'Presentation and objects',
    learning_objectives: 'Don\'t forget to briefly describe the learning objectives.',
    teaching_staff: 'Methodology and teaching staff',
    public: 'Public',
    content: 'Content',
    sidebar: 'Side Bar',
    //ProductBrandingComponent
    banner: 'Banner',
    upload_banner: 'Upload your banner',
    banner_format: 'PNG, JPG, GIF up to 3MB',
    promotional_video: 'Promotional Video',
    video_url: 'Video URL',
    video_info: 'If you have a promotional video, place here the url of the video on Youtube or Vimeo.',
    //SellComponent
    price_management: 'Price Management',
    sell_price: 'Selling price',
    tax: 'In €. (-3% tax)',
    price_offer: 'Offer Price',
    text_configuration: 'Text configuration',
    free_text_button: 'Free buy button title',
    text_if_free: 'This title will appear if your product is free',
    on_sale: 'For sale',
    sale_info: 'If activated your product will be for sale',

    //SeoComponent
    seo_configuration: 'SEO Configuration',
    seo_title: 'SEO Title',
    slug: 'Slug',
    seo_description: 'SEO Description',

    //ProjectListComponent
    featured: 'Featured',
    classroom: 'Classroom',
    slug_text: 'slug',
    project: 'proyect',
    projects: 'proyects',
    preview: 'Preview',

    //ProjectAccessComponent
    access_project: 'Access to the course',
    draft: 'Draft',
    draft_text: 'This project will not be shown in the catalog and may be edited.',
    published: 'Published',
    published_text: 'This project is published and users will be able to access it.',
    private: 'Private',
    private_text: 'This project is private, the users of this course will register manually',
    coming_soon_access: 'Coming soon',
    coming_soon_access_text: 'This project will be displayed in the course catalog, but will not be accessible',
    enrollment_closed: 'Enrollment closed',
    enrollment_closed_text: 'Only enrolled users will be able to enter the course. The course will appear in the catalog but new users will not be able to enroll.',
    course_expiration: 'Course expiration',
    project_expiration_info: 'Your course will be accessible during this period of time. At the end of this period, enrolled users will be denied access to the course.',
    init_date: 'Start Date',
    project_delete: 'Delete',
    init_date_selected: 'Selected start date',
    end_date: 'End Date',
    date_delete: 'Delete',
    end_date_selected: 'Selected end date',

    //ProjectContentComponent
    new_section: 'New Section',
    section_title: 'Section title: ',
    create_section: 'Create section',
    import_section: 'Import section',
    lesson_title: 'Lesson title:',
    new_lesson: 'New lesson',

    //AttachProductSlideOverComponent
    attach_product_slide: 'Associate Product',
    selected_product: 'Selected product',
    quest_attach_product: 'Do you want to attach this product?',

    //ProjectEditContentComponent
    back: 'Return',
    select_type_content: 'Select the type of content',
    type_lesson: 'Type of lesson: ',
    html_editor: 'HTML Editor',
    html_info_text: 'Insert the HTML code you want to display in your lesson',
    insert_video_url: 'Insert the URL of the video',
    content_index: 'Table of Contents',
    student_list: 'Students List',

    //ProjectLayoutContent
    image: 'Image',
    classic_design: 'Classic Appearance',

    //Visibilidad staff (FE-001)
    edit_project: 'Edit course',

    //Listado de proyectos (FE-003)
    empty_projects_title: 'There are no courses yet',
    empty_projects_text: 'Courses created in this academy will appear here.',
    export_students: 'Export students',
    unexpected_error: 'An unexpected error occurred',

    //Contenedor de edición (FE-005)
    loading_project: 'Loading course...',

    //Secciones del contenido (FE-006)
    course_content: 'Course content',
    section_title_label: 'Section title',
    section_title_placeholder: 'E.g.: Introduction',
    section_title_required: 'The section title is required',
    section_created: 'Section created',
    section_saved: 'Section saved',

    //Estados vacíos y lecciones (FE-008)
    empty_sections_title: 'This course has no content yet',
    empty_sections_text: 'Create a section to start organising lessons.',
    empty_lessons: 'This section has no lessons yet.',
    add_lesson: 'Add lesson',
    lesson_title_label: 'Lesson title',
    lesson_title_placeholder: 'E.g.: Welcome to the course',
    lesson_title_required: 'The lesson title is required',
    lesson_created: 'Lesson created',
    edit_lesson_content: 'Edit lesson content',

    //Pantalla de lección (FE-009)
    back_to_content: 'Back to content',
    loading_lesson: 'Loading lesson...',

    //Cabecera de lección con contexto (FE-053)
    lesson_breadcrumb: 'Lesson position in the course',
    section_n: 'Section {number}',
    lesson_n_of_total: 'Lesson {number} of {total}',
    previous_lesson: 'Previous',
    next_lesson: 'Next',
    previous_lesson_named: 'Previous lesson: {title}',
    next_lesson_named: 'Next lesson: {title}',
    course_outline_short: 'Outline',
    course_outline: 'Course outline',
    current_lesson: '(current lesson)',
    rename_lesson_named: 'Rename lesson "{title}"',
    view_as_student: 'View as student',
    opens_in_new_tab: '(opens in a new tab)',

    lesson_editing_coming_soon: 'Lesson content editing will be available soon.',

    //Adjuntar producto (FE-010)
    product_attached: 'Product attached to the course',
    product_detached: 'Product detached from the course',

    //Pestaña General (FE-011)
    status_label: 'Status',
    general_editing_coming_soon: 'Editing course details (title, status, deletion) will be available soon.',

    //Pestaña Acceso (FE-012)
    enrol_configuration: 'Enrolment settings',
    enrol_configuration_empty: 'Click the button to create an enrolment configuration. Students will start and end their enrolment in the course according to it.',
    enrol_configuration_create: 'Configure enrolment',
    enrol_time_start: 'Start time',
    enrol_time_end: 'End time',
    enrol_time_value: 'Amount',
    enrol_time_unit: 'Time unit',
    time_unit_hours: 'Hours',
    time_unit_days: 'Days',
    time_unit_weeks: 'Weeks',
    time_unit_months: 'Months',
    time_unit_years: 'Years',
    enrol_configuration_invalid_value: 'Times must be whole numbers equal to or greater than 0',
    enrol_configuration_invalid_unit: 'Select a valid time unit',
    enrol_configuration_saved: 'Enrolment settings saved',
    enrol_configuration_deleted: 'Enrolment settings deleted',

    //Textos del editor de contenido (FE-013)
    drag_section: 'Drag to reorder the section',
    drag_lesson: 'Drag to reorder the lesson',
    delete_section: 'Delete section',
    delete_lesson: 'Delete lesson',
    sections_order_saved: 'Section order saved',
    sections_order_error: 'Error saving the section order',
    lessons_order_saved: 'Lesson order saved',
    lessons_order_error: 'Error saving the lesson order',

    //Claves que faltaban respecto a es (FE-013)
    attached_products: 'Attached products',
    attach_product: 'Attach product',
    loading_attached_products: 'Loading attached products...',
    unattach_product: 'Detach product',
    info_unattach_product: 'If you detach the product from the course, students who buy it will not be able to access the course.',
    quest_unattach_product: 'Are you sure you want to detach the product ',
    no_product_attached: 'NO ATTACHED PRODUCTS',

    // FE-020 · Borrar secciones y lecciones
    delete_section_title: 'Delete the section “{title}”?',
    delete_section_message: 'The section will be removed from the course.',
    delete_section_with_lessons_message: 'The section contains {count} lesson(s) that will also be deleted. Students will no longer see them.',
    delete_lesson_title: 'Delete the lesson “{title}”?',
    delete_lesson_message: 'The lesson and its content will be removed from the course.',
    delete_confirm_button: 'Delete',
    section_deleted: 'Section deleted',
    lesson_deleted: 'Lesson deleted',

    // FE-021 · Renombrar lecciones
    lesson_saved: 'Lesson saved',

    // FE-022 · Reordenar y mover lecciones
    move_section_up: 'Move section up',
    move_section_down: 'Move section down',
    move_lesson_up: 'Move lesson up',
    move_lesson_down: 'Move lesson down',
    empty_lessons_drop: 'This section has no lessons yet. Add one or drag one here from another section.',

    // FE-023 · Publicar y vista previa gratuita
    status_published: 'Published',
    status_draft: 'Draft',
    publish_section: 'Publish section',
    unpublish_section: 'Unpublish section',
    publish_lesson: 'Publish lesson',
    unpublish_lesson: 'Unpublish lesson',
    section_published: 'Section published',
    section_unpublished: 'Section unpublished: students can no longer see it',
    lesson_published: 'Lesson published',
    lesson_unpublished: 'Lesson unpublished: students can no longer see it',
    free_preview_badge: 'Preview',
    free_preview_enabled: 'The lesson is now a free preview',
    free_preview_disabled: 'The lesson is no longer a free preview',

    //Editor de lección por bloques (FE-030)
    loading_blocks: 'Loading lesson content...',
    drag_block: 'Drag to reorder the block',
    move_block_up: 'Move block up',
    move_block_down: 'Move block down',
    delete_block: 'Remove block',
    block_type_not_editable: 'This block type cannot be edited here yet.',
    add_block: 'Add block',
    discard_changes: 'Discard changes',
    blocks_load_error: 'The lesson content could not be loaded',
    blocks_saved: 'Lesson content saved',
    blocks_save_error: 'Error saving the lesson content',
    block_type_rich_text: 'Text',
    block_rich_text_required: 'The text block cannot be empty',

    //Barra de guardado y estados del editor (FE-051)
    empty_blocks_title: 'This lesson has no content yet',
    empty_blocks_text: 'Add a text block, an embedded page or another type to get started.',
    add_first_block: 'Add the first block',
    blocks_status_dirty: 'Unsaved changes',
    blocks_status_saving: 'Saving...',
    blocks_status_saved_at: 'Saved at {time}',
    blocks_status_clean: 'No changes',
    blocks_errors_count: '{count} block with errors | {count} block with errors | {count} blocks with errors',
    blocks_go_to_first_error: 'Go to the first one',
    save_shortcut_title: 'Save ({shortcut})',
    save_shortcut_hint: '{shortcut} to save',
    discard_confirm_title: 'Discard changes?',
    discard_confirm_text: 'The lesson will go back to how it was the last time you saved it.',

    //Guardado en lote del editor de bloques (FE-055)
    blocks_conflict_title: 'Someone else has saved this lesson',
    blocks_conflict_text: 'Your changes are still on screen. If you reload, you will see the saved version and lose what you have not saved.',
    blocks_conflict_reload: 'Reload the lesson',
    blocks_conflict_keep: 'Keep editing',
    blocks_conflict_status: 'Someone else has saved this lesson. Reload to be able to save.',
    blocks_conflict_fallback: 'Someone else saved this lesson while you were editing it.',

    //Insertar y manejar bloques (FE-052)
    block_actions: 'Block actions',
    block_position: 'Block {position} of {total}',
    collapse_block: 'Collapse block',
    expand_block: 'Expand block',
    duplicate_block: 'Duplicate',
    move_block_first: 'Move to the top',
    move_block_last: 'Move to the bottom',
    insert_block_after: 'Insert a block after block {position}',
    block_type_rich_text_description: 'Paragraphs, headings, lists, links and images.',
    block_type_embed_description: 'Forms, documents or presentations from allowed services.',
    block_type_video_description: 'YouTube or Vimeo video.',
    block_type_quiz_description: 'Questions with automatic grading.',

    //Bloque de página embebida (FE-050)
    block_type_embed: 'Embedded page',
    block_embed_url_invalid: 'Enter the full page address, starting with https://',
    block_embed_height_invalid: 'The height must be a whole number between 100 and 3000 pixels',
    block_embed_domain_not_allowed: 'The domain {host} is not allowed for embedded pages',
    embed_url_label: 'Page address',
    embed_url_placeholder: 'https://docs.google.com/forms/...',
    embed_url_help: 'Only https pages from allowed services, such as Google Forms, Google Docs, Microsoft Forms or Slidebean.',
    embed_height_label: 'Height (pixels)',
    embed_height_help: 'Between {min} and {max}. Leave it empty to use the default height.',
    embed_preview: 'Preview',
    embed_preview_title: 'Embedded page preview',
    embed_preview_after_save: 'The preview will appear once you save the lesson.',

    //Bloque de imagen (FE-057)
    block_type_image: 'Image',
    block_type_image_description: 'An image with alternative text and an optional caption.',
    block_image_required: 'Upload an image for this block',
    block_image_alt_required: 'Write the alternative text for the image',
    block_image_file_invalid: 'The image is no longer available: upload another one',
    image_choose: 'Choose image',
    image_replace: 'Change image',
    image_drop_hint: 'or drag it here',
    image_file_help: 'JPG, PNG, GIF or WebP. {max} MB maximum.',
    image_uploading: 'Uploading image... {progress} %',
    image_preview_unavailable: 'The image preview cannot be shown.',
    image_type_invalid: 'Unsupported format: use JPG, PNG, GIF or WebP',
    image_too_large: 'The image is larger than {max} MB',
    image_upload_throttled: 'You have uploaded many images in a row. Wait a minute and try again.',
    image_upload_error: 'The image could not be uploaded. Please try again.',
    image_alt_label: 'Alternative text (required)',
    image_alt_help: 'Describe in one sentence what the image shows and why it matters in the lesson, for example "Sales chart growing every quarter of 2025". Do not start with "Image of".',
    image_caption_label: 'Caption (optional)',

    //Bloque de archivos descargables (FE-058)
    block_type_file: 'Downloadable files',
    block_type_file_description: 'Documents or other files for students to download.',
    block_file_required: 'Upload at least one file for this block',
    block_file_too_many: 'This block has too many files: remove some',
    block_file_invalid: 'A file is no longer available: remove it and upload it again',
    block_file_name_invalid: 'A file display name is too long (maximum 255 characters)',
    file_empty: 'This block has no files yet.',
    file_list_label: 'Block files ({count})',
    file_drag: 'Drag to reorder the file',
    file_open_new_tab: 'opens in a new tab',
    file_name_label: 'Display name (optional)',
    file_move_up: 'Move file up',
    file_move_down: 'Move file down',
    file_remove: 'Remove file',
    file_missing: 'This file is no longer available. Remove it from the block.',
    file_unnamed: 'Unnamed file',
    file_uploading: 'Uploading... {progress} %',
    file_queued: 'Waiting',
    file_retry: 'Retry upload',
    file_dismiss: 'Dismiss',
    file_choose: 'Choose files',
    file_add_more: 'Add more files',
    file_drop_hint: 'or drag them here',
    file_limit_reached: 'You have reached the maximum of {max} files in this block.',
    file_help: 'PDF, Word, Excel, PowerPoint, OpenDocument, RTF, TXT, CSV, ZIP, images (JPG, PNG, GIF, WebP) or MP3. Up to {max} MB per file and {count} files per block.',
    file_type_invalid: 'Unsupported format',
    file_too_large: 'The file is larger than {max} MB',
    file_too_many: 'No more files fit: the maximum is {max} per block',
    file_upload_throttled: 'You have uploaded many files in a row. Wait a minute and try again.',
    file_upload_error: 'The file could not be uploaded. Please try again.',

    //Bloque de vídeo (FE-031)
    block_type_video: 'Video',
    block_video_required: 'Upload a video or paste a YouTube or Vimeo link',
    video_source_label: 'Video source',
    video_source_upload: 'Upload video',
    video_source_embed: 'YouTube or Vimeo link',
    video_uploaded: 'Video uploaded',
    video_upload_error: 'Error uploading the video',
    video_url_label: 'Video link',
    video_url_placeholder: 'https://www.youtube.com/watch?v=...',
    video_url_help: 'YouTube (including Shorts and youtu.be) and Vimeo links are supported.',
    video_preview: 'Preview',
    video_url_unsupported: 'The link is not a valid YouTube or Vimeo link',
    video_url_error: 'The video link could not be checked',

    //Editor de quizzes (FE-033)
    block_type_quiz: 'Quiz',
    block_quiz_required: 'Create the quiz before saving',
    quiz_empty: 'This block does not have a quiz yet.',
    quiz_create: 'Create quiz',
    quiz_default_title: 'Quiz',
    quiz_created: 'Quiz created. Save the lesson to keep it in this block.',
    quiz_loading: 'Loading quiz...',
    quiz_load_error: 'The quiz could not be loaded',
    retry: 'Retry',
    quiz_save_error: 'Error saving the quiz',
    quiz_settings_saved: 'Quiz settings saved',
    quiz_title_label: 'Quiz title',
    quiz_pass_percentage_label: 'Pass mark (%)',
    quiz_max_attempts_label: 'Maximum attempts',
    quiz_unlimited: 'Unlimited',
    quiz_max_attempts_help: 'Leave empty to allow unlimited attempts.',
    quiz_required_to_progress: 'Must pass to continue',
    quiz_shuffle: 'Shuffle questions and answers',
    quiz_save_settings: 'Save settings',
    quiz_title_required: 'The quiz title is required',
    quiz_pass_percentage_invalid: 'The pass mark must be a whole number between 0 and 100',
    quiz_max_attempts_invalid: 'Attempts must be a whole number greater than 0',
    quiz_questions_title: 'Questions ({count})',
    quiz_no_questions: 'Add at least one question.',
    quiz_add_question: 'Add question',
    quiz_edit_question: 'Edit question',
    quiz_delete_question: 'Delete question',
    quiz_delete_question_title: 'Delete this question?',
    quiz_delete_question_text: 'The question and its answers will be deleted from the quiz. This cannot be undone.',
    quiz_question_saved: 'Question saved',
    quiz_question_deleted: 'Question deleted',
    quiz_drag_question: 'Drag to reorder the question',
    quiz_move_question_up: 'Move question up',
    quiz_move_question_down: 'Move question down',
    quiz_order_error: 'Error saving the question order',
    quiz_remove_block_title: 'Remove the quiz block?',
    quiz_remove_block_text: 'When you save the lesson, the quiz will be deleted along with its questions and the students\' attempts. Until you save, you can discard the changes to get it back.',
    quiz_orphan_delete_error: 'The lesson has been saved, but the quiz of a removed block could not be deleted. It will be tried again the next time you save.',
    quiz_statement_label: 'Question',
    quiz_question_type_label: 'Question type',
    quiz_type_single: 'Single choice',
    quiz_type_multiple: 'Multiple choice',
    quiz_options_label: 'Answers',
    quiz_options_help_single: 'Mark the only correct answer.',
    quiz_options_help_multiple: 'Mark all correct answers.',
    quiz_correct: 'Correct',
    quiz_option_text_label: 'Answer {number}',
    quiz_option_feedback_label: 'Feedback when chosen (optional)',
    quiz_add_option: 'Add answer',
    quiz_remove_option: 'Remove answer',
    quiz_explanation_label: 'Explanation (optional)',
    quiz_explanation_help: 'Shown to the student after answering.',
    quiz_question_type_required: 'Choose the question type',
    quiz_statement_required: 'The question text is required',
    quiz_min_options: 'Add at least two answers',
    quiz_option_text_required: 'All answers must have text',
    quiz_single_requires_one_correct: 'Mark exactly one correct answer',
    quiz_multiple_requires_correct: 'Mark at least one correct answer',

    // FE-040 · Crear curso desde el panel
    new_course: 'New course',
    new_course_title: 'Create a course',
    new_course_text: 'It will be created as a draft. You can then add content and complete its details.',
    course_title_label: 'Course title',
    course_title_placeholder: 'E.g.: Introduction to photography',
    course_title_required: 'The course title is required',
    create_course: 'Create course',
    course_created: 'Course created',

    // FE-041 · Editar la ficha del curso
    archived: 'Archived',
    course_details_loading: 'Loading course details...',
    course_subtitle_label: 'Subtitle',
    course_description_label: 'Description',
    course_cover_label: 'Cover image',
    course_cover_alt: 'Course cover',
    course_cover_empty: 'No cover',
    course_cover_help: '16:9 image (1280×720 recommended), up to 5 MB.',
    course_cover_invalid: 'Select an image of 5 MB or less',
    course_slug_label: 'Friendly URL (slug)',
    course_slug_help: 'Lowercase letters, numbers and hyphens only. Leave empty to generate it from the title.',
    course_slug_invalid: 'The slug can only contain lowercase letters, numbers and hyphens',
    course_saved: 'Course details saved',

    // FE-042 · Duplicar y borrar curso
    duplicate_course: 'Duplicate course',
    course_duplicated: 'Course duplicated. The copy is a draft.',
    delete_course: 'Delete course',
    delete_course_help: 'The course will no longer be available to students. This action cannot be undone from the panel.',
    delete_course_title: 'Delete this course?',
    delete_course_text: 'The course, its sections and its lessons will be deleted. Student history is kept.',
    delete_course_has_students: 'This course has enrolled students and they will lose access. To continue, confirm again.',
    delete_course_confirmation_label: 'To confirm, type the course name:',
    delete_course_force: 'Delete anyway',
    course_deleted: 'Course deleted',

    // ProjectContentComponent · rediseño del editor de contenido
    sections_count: 'No sections | 1 section | {count} sections',
    lessons_count: 'No lessons | 1 lesson | {count} lessons',
    create_lesson: 'Create lesson',
    section_number: 'Section {number} title',
    edit_content: 'Edit',
    edit_lesson_content_of: 'Edit the content of "{title}"',

    //Secciones plegables con resumen (FE-061)
    expand_all_sections: 'Expand all',
    collapse_all_sections: 'Collapse all',
    expand_section: 'Expand section "{title}"',
    collapse_section: 'Collapse section "{title}"',
    section_actions: 'Actions for section "{title}"',
    lessons_published_count: 'none published | 1 published | {count} published',

    //Programación (drip) dentro de la sección (FE-062)
    drip_menu: 'Schedule',
    drip_title: 'Section schedule',
    drip_help: 'Choose when students can see this section.',
    drip_immediate: 'Available from enrolment',
    drip_days_option: 'Some days after enrolment',
    drip_days_label: 'Days after enrolment',
    drip_days_suffix: 'days after enrolment',
    drip_date_option: 'On a fixed date',
    drip_date_label: 'Date from which it is available',
    drip_days_invalid: 'Enter a whole number of days between {min} and {max}',
    drip_date_invalid: 'Choose a valid date',
    drip_saved: 'Section schedule saved',
    drip_badge_days: '{count} days after enrolment | 1 day after enrolment | {count} days after enrolment',
    drip_badge_date: 'From {date}',
    drip_edit_of: 'Edit the schedule of "{title}": {schedule}',

    //Filas de lección simplificadas (FE-063)
    lesson_title_edit_hint: 'Click to rename. Enter saves and Escape undoes.',
    saved_inline: 'Saved',
    free_preview_enable: 'Enable free preview',
    free_preview_enable_help: 'Any visitor will be able to see this lesson without buying the course.',
    free_preview_disable: 'Remove free preview',
    lesson_actions: 'Actions for lesson "{title}"',

    //Duplicar y acciones en lote (FE-065)
    duplicate_lesson: 'Duplicate',
    duplicate_lesson_help: 'The copy is created right below, as a draft.',
    duplicate_section: 'Duplicate section',
    duplicate_section_help: 'Copies the section with its lessons right below, as a draft.',
    lesson_duplicated: 'Lesson duplicated',
    section_duplicated: 'Section duplicated',
    publish_section_with_lessons: 'Publish section and lessons',
    unpublish_section_with_lessons: 'Unpublish section and lessons',
    publish_section_with_lessons_title: 'Publish "{title}" with its lessons?',
    unpublish_section_with_lessons_title: 'Unpublish "{title}" with its lessons?',
    publish_section_with_lessons_message: 'The section will be published. All its lessons are already published. | The section and {count} draft lesson will be published. Students will be able to see them. | The section and {count} draft lessons will be published. Students will be able to see them.',
    unpublish_section_with_lessons_message: 'The section will be unpublished. None of its lessons is published. | The section and {count} published lesson will be unpublished. Students will no longer see them. | The section and {count} published lessons will be unpublished. Students will no longer see them.',
    section_with_lessons_published: 'Section and lessons published',
    section_with_lessons_unpublished: 'Section and lessons unpublished',
    bulk_publish_partial_error: 'No item could be changed | {count} item could not be changed: check its status and try again. | {count} items could not be changed: check their status and try again.',

    //Currículo en móvil (FE-064)
    rename_section: 'Rename section "{title}"',
    rename_lesson: 'Rename lesson "{title}"',
}
